import { Grid, styled } from "@mui/material";
import { IndexList } from "./Common/IndexList";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { useState } from "react";
import { ComparisonCard, ComparisonData } from "./Common/ComparisonCard";

type SummaryLayoutProps = {
    items: ComparisonData[];
};
export const SummaryLayout = (props: SummaryLayoutProps) => {
    const {
        scoreList: { lastSelected },
    } = useScoreDetailContext();
    const { items } = props;

    const [selectedIndex, setSelectedIndex] = useState<string>(items[0].key);
    const selectedItem = items.find((i) => i?.title === selectedIndex);

    return (
        <Grid container spacing={2}>
            <Grid item xs={3}>
                <IndexList
                    items={items}
                    selectedIndex={selectedIndex}
                    onClick={(newIndex) => {
                        setSelectedIndex(newIndex);
                    }}
                />
            </Grid>
            <ComparisonScoreGrid item xs={9}>
                <ComparisonCard score={selectedItem} unit={lastSelected.unit} scorePrecision={lastSelected.precision} />
            </ComparisonScoreGrid>
        </Grid>
    );
};

const ComparisonScoreGrid = styled(Grid)<{ direction?: "row" | "column" }>(({ theme, direction = "row" }) => ({
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: direction,
    padding: theme.spacing(2),
    height: "100%",
    width: "100%",
}));
